import React, { useCallback } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";

import { AuthSelectors } from "src/redux/Auth/selectors";
import { useDispatch, useSelector } from "react-redux";
import {
    postTradePositionsColumnDefs,
    defaultColDef,
    autoGroupColumnDef,
} from "./column_defs";
import styles from "./styles.module.scss";
import "src/styles/agGridCustom.scss";
import fetchWrapper from "src/utils/fetchWrapper";

const getLastRowIndex = (request, response) => {
    if (!response) return undefined;
    return response.lastRow < request.endRow ? response.lastRow : undefined;
};

const Positions = () => {
    const dispatch = useDispatch();

    const postTradePositionsUrl = useSelector(
        AuthSelectors.BuildPostTradePositionsUrl
    );

    // Note: expecting this to be done on the backend
    // this code is only to mimic the backend grouping logic
    const processGroupedData = (data, request) => {
        const { groupKeys = [] } = request;

        if (groupKeys.length === 0) {
            // Return top-level groups
            const groups = {};
            data.forEach((row) => {
                const borrower = row.borrower;
                if (!groups[borrower]) {
                    groups[borrower] = {
                        borrower,
                        outstanding_trades: 0,
                        notional_outstanding: 0,
                        required_collateral: 0,
                    };
                }
                groups[borrower].outstanding_trades += 1;
                groups[borrower].notional_outstanding +=
                    row.notional_outstanding;
                groups[borrower].required_collateral += row.required_collateral;
            });

            const groupArray = Object.values(groups);
            console.log("group parent rows: ", {
                data: groupArray,
                lastRow: groupArray.length,
            });
            return {
                data: groupArray,
                lastRow: groupArray.length,
            };
        } else if (groupKeys.length === 1) {
            // return child rows for the expanded group
            const borrower = groupKeys[0];
            const filteredData = data.filter(
                (row) => row.borrower === borrower
            );
            console.log("group child rows: ", {
                data: filteredData,
                lastRow: filteredData.length,
            });
            return {
                data: filteredData,
                lastRow: filteredData.length,
            };
        }

        return [];
    };

    const createServerSideDatasource = useCallback(() => {
        return {
            getRows: (params) => {
                const body = JSON.stringify(params.request);

                dispatch(
                    fetchWrapper(postTradePositionsUrl, {
                        method: "POST",
                        body,
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                        },
                    })
                )
                    .then((response) => {
                        const data = response.data || [];
                        params.successCallback(
                            data,
                            getLastRowIndex(params.request, response)
                        );
                    })
                    .catch((error) => {
                        console.error(
                            "Error fetching post-trade positions data:",
                            error
                        );
                        params.failCallback();
                    });
            },
        };
    }, [dispatch, postTradePositionsUrl]);

    const onGridReady = useCallback(
        (params) => {
            const datasource = createServerSideDatasource();
            params.api.setServerSideDatasource(datasource);
        },
        [createServerSideDatasource]
    );

    return (
        <div className={`${styles.table} ag-theme-alpine-dark`}>
            <AgGridReact
                defaultColDef={defaultColDef}
                columnDefs={postTradePositionsColumnDefs}
                headerHeight={40}
                groupHeaderHeight={40}
                rowHeight={40}
                rowModelType="serverSide"
                serverSideStoreType={"partial"}
                onGridReady={onGridReady}
                rowBuffer={100}
                cacheBlockSize={50}
                blockLoadDebounceMillis={500}
                animateRows={true}
                groupDisplayType="singleColumn"
                groupDefaultExpanded={-1}
                suppressRowClickSelection={true}
                rowGroupPanelShow="never"
                suppressAggFuncInHeader={true}
                autoGroupColumnDef={autoGroupColumnDef}
                enableServerSideFilter={true}
            />
        </div>
    );
};

export default Positions;
